import Card from "common/TourItem";
export default function TourOrdersTab() {
  let data =[
    {
      title: "عنوان تور",
      description: "کیش",
    },
    {
      title: "نام خریدار",
      description: "محمد طاشی",
    },
    {
      title: "تعداد ثبت نامی",
      description: "4",
    },
    {
      title: "مبلغ تور",
      description: 200000,
    },
    {
      title: "قیمت کل",
      description: 800000,
    },
    {
      title: "تاریخ",
      description: "1400/12/05",
    },
    {
      title: "مبلغ پرداخت شده",
      description: 0,
    },
    {
      title: "مانده حساب",
      description: 800000,
    },
  ]
  return (
    <div class="tab-pane fade  " id="tour-orders">
      {[...Array(5)].map((value, index) => {
        return <Card index={index} data={data} type="order"></Card>;
      })}
    </div>
  );
}
